export const GET_SLOTS = 'GET_SLOTS';
const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
